// eslint-disable-next-line import/no-extraneous-dependencies
import 'shepherd.js/dist/css/shepherd.css'
import Vue from 'vue'
import VueShepherd from 'vue-shepherd'

Vue.use(VueShepherd)
